exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._16UHoQYUMOc1g3VJjHUCi_{width:100%}.uL4IOpqIg-32bpgqyGxx_{background-position:50%;background-repeat:no-repeat;-webkit-background-size:contain;-moz-background-size:contain;background-size:contain;content:\"\";cursor:pointer;display:block;font-size:.85714rem;-webkit-transition:-webkit-transform .3s ease-in-out;transition:-webkit-transform .3s ease-in-out;-o-transition:-o-transform .3s ease-in-out;-moz-transition:transform .3s ease-in-out,-moz-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out,-moz-transform .3s ease-in-out,-o-transform .3s ease-in-out}.uL4IOpqIg-32bpgqyGxx_._1yOWJ_ohHaDI9Rv8fdw9Od{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-ms-transform:rotate(180deg);-o-transform:rotate(180deg);transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ViewNav": "_16UHoQYUMOc1g3VJjHUCi_",
	"ViewNav_expandIcon": "uL4IOpqIg-32bpgqyGxx_",
	"__reverse": "_1yOWJ_ohHaDI9Rv8fdw9Od"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/MidtermAndFinalExamHFv4/ViewNavHFv4/style.postcss
// module id = 1891
// module chunks = 0